import { lazy } from 'react';
import { Outlet, Route } from 'react-router';

import { AreaName } from 'domain/constants';
import { OperationType } from 'library/models/enums/OperationType';
import { createArea } from 'library/utils/helpers/AreaHelper';
import Authorize from 'main/auth/Authorize';

import LazyRouteElement from './common/LazyRoute';
import {
	UNIT_ROUTES,
	unitEditEndCustomerConnect,
	unitRelativeUrl,
} from './urls/RouteUrls';

const CommissioningPage = lazy(
	() => import('pages/unit/UnitCommissioningPage')
);
const AddEndCustomerPage = lazy(
	() => import('pages/unit/UnitAddEndCustomerPage')
);
const ProductInOperationPage = lazy(
	() => import('pages/unit/UnitProductInOperationPage')
);
const UnitEditPage = lazy(() => import('pages/unit/UnitEditPage'));

const UnitEditConnectedCustomersPage = lazy(
	() => import('pages/unit/UnitEditConnectedCustomersPage')
);

const RelocateToPage = lazy(() => import('pages/relocateTo/RelocateToPage'));

export const getUnitRoutes = (): React.JSX.Element[] => {
	return [
		<Route
			key={UNIT_ROUTES.unitAddEndCustomer}
			path={UNIT_ROUTES.unitAddEndCustomer}
			element={
				<Authorize
					area={createArea(AreaName.Unit, OperationType.Create)}>
					<Outlet />
				</Authorize>
			}>
			<Route
				index
				element={
					<LazyRouteElement
						Component={AddEndCustomerPage}
						path={UNIT_ROUTES.unitAddEndCustomer}
					/>
				}
			/>
			<Route
				path={unitRelativeUrl}
				element={
					<LazyRouteElement
						Component={AddEndCustomerPage}
						path={unitRelativeUrl}
					/>
				}
			/>
		</Route>,
		<Route
			key={UNIT_ROUTES.unitProductInOperation}
			path={UNIT_ROUTES.unitProductInOperation}
			element={
				<Authorize
					area={createArea(
						AreaName.ProductInOperation,
						OperationType.Create
					)}>
					<Outlet />
				</Authorize>
			}>
			<Route
				index
				element={
					<LazyRouteElement
						Component={ProductInOperationPage}
						path={UNIT_ROUTES.unitProductInOperation}
					/>
				}
			/>
			<Route
				path={unitRelativeUrl}
				element={
					<LazyRouteElement
						Component={ProductInOperationPage}
						path={unitRelativeUrl}
					/>
				}
			/>
		</Route>,
		<Route
			key={UNIT_ROUTES.unitCommissioning}
			path={UNIT_ROUTES.unitCommissioning}
			element={
				<Authorize
					area={createArea(
						AreaName.Commissioning,
						OperationType.Create
					)}>
					<Outlet />
				</Authorize>
			}>
			<Route
				index
				element={
					<LazyRouteElement
						Component={CommissioningPage}
						path={UNIT_ROUTES.unitCommissioning}
					/>
				}
			/>
			<Route
				path={unitRelativeUrl}
				element={
					<LazyRouteElement
						Component={CommissioningPage}
						path={unitRelativeUrl}
					/>
				}
			/>
		</Route>,
		<Route
			key={UNIT_ROUTES.unitEdit}
			path={UNIT_ROUTES.unitEdit}
			element={
				<Authorize
					area={createArea(AreaName.Unit, OperationType.Write)}>
					<Outlet />
				</Authorize>
			}>
			<Route
				index
				element={
					<LazyRouteElement Component={UnitEditPage} path={UNIT_ROUTES.unitEdit} />
				}
			/>
			<Route
				path={unitRelativeUrl}
				element={
					<LazyRouteElement
						Component={UnitEditPage}
						path={unitRelativeUrl}
					/>
				}
			/>
		</Route>,
		<Route
			key={UNIT_ROUTES.unitEditEndCustomer}
			path={UNIT_ROUTES.unitEditEndCustomer}
			element={
				<Authorize
					area={createArea(AreaName.Unit, OperationType.Create)}>
					<Outlet />
				</Authorize>
			}>
			<Route
				path={`${unitRelativeUrl}/${unitEditEndCustomerConnect}`}
				element={
					<LazyRouteElement
						Component={UnitEditConnectedCustomersPage}
						path={`${unitRelativeUrl}/${unitEditEndCustomerConnect}`}
					/>
				}
			/>
		</Route>,
		<Route
			key={UNIT_ROUTES.unitRelocateTo}
			path={UNIT_ROUTES.unitRelocateTo}
			element={
				<Authorize
					area={createArea(
						AreaName.TransferUnit,
						OperationType.Create
					)}>
					<Outlet />
				</Authorize>
			}>
			<Route
				path={unitRelativeUrl}
				element={
					<LazyRouteElement
						Component={RelocateToPage}
						path={unitRelativeUrl}
					/>
				}
			/>
		</Route>,
	];
};
